<template>
    <footer class="footer">
        <div class="content has-text-centered">
            <p>
                <strong>BOOST</strong> stworzony przez <a href="https://github.com/dudematthew" target="_blank">Mateusza
                    Moczydłowskiego</a>. Prawdziwe losowe liczby generowane przez <a href="www.random.org"
                    target="_blank">RANDOM.ORG</a>.
                <br />
                Zarówno system jak i strona są na licencji <a href="http://opensource.org/licenses/mit-license.php" target="_blank">MIT</a>. 
                Możesz je modyfikować i używać w swoich kreacjach jak tylko dusza zapragnie ale podlinkuj gdzieś tę stronę.
                <br />
                Chcesz pomóc przy tworzeniu? Utwórz <a href="https://github.com/dudematthew/boost-rpg-tools/fork" target="_blank">fork</a> projektu tej strony na <a href="https://github.com/dudematthew/boost-rpg-tools" target="_blank">githubie</a>.
            </p>
        </div>
    </footer>
</template>

<script>
    export default {
        name: 'Footer'
    }
</script>